// baseUrl.js
import API from './api'

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
// API.get('/api/me')
//   .then(res => console.log(res.data))
//   .catch(err => console.error(err.response?.data || err.message));


export default API_BASE_URL;
